<template>
  <v-navigation-drawer
    app
    width="408"
    :value="drawer"
    :bottom="$vuetify.breakpoint.xsOnly"
    class="elevation-4"
    hide-overlay
    mobile-break-point="xsOnly"
  >
    <div class="overlap"></div>
    <main-loading v-show="loading" />
    <template v-slot:prepend>
      <nav class="elevation-1">
        <v-list-item two-line>
          <search></search>
        </v-list-item>
        <v-list>
          <filter-panel></filter-panel>
        </v-list>
      </nav>
    </template>
    <template v-if="selectedItemType === 'Facility'">
      <facility class="elevation-0"></facility>
    </template>
    <template v-else>
      <intro-copy></intro-copy>
      <nav-panel-list-info></nav-panel-list-info>
    </template>
    <template v-slot:append>
      <div class="pa-2">
        <v-btn block tile alt="print" :loading="printing" @click="getFactsheet">
          <v-icon color="grey darken-1">mdi-printer</v-icon>
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import Search from '@/components/nav-panel-search';
import FilterPanel from '@/components/filter-panel';
import IntroCopy from '@/components/intro-copy';
import NavPanelListInfo from '@/components/nav-panel-list-info';
import Facility from '@/components/nav-panel-facility';
import MainLoading from '@/components/main-loading';
import Print from '@/api/Print';
import appConfig from '@/config/appConfig';

import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'NavPanelDrawer',
  components: {
    Search,
    FilterPanel,
    IntroCopy,
    NavPanelListInfo,
    Facility,
    MainLoading
  },
  data: () => ({ printing: false }),
  computed: {
    ...mapState(['drawer']),
    ...mapGetters({
      selectedItemType: 'mapTemplate/selectedItemType',
      selectedItemValue: 'mapTemplate/selectedItemValue',
      loading: 'mapTemplate/loading',
      currentView: 'currentView',
      linkToFactsheet: 'mapTemplate/geographyLinkToFactsheetValue'
    })
  },
  methods: {
    ...mapActions({
      selectLocation: 'geographyTemplate/selectLocation'
    }),
    ...mapMutations(['setCurrentView', 'setError']),
    getFactsheet: function () {
      let location = this.selectedItemValue;
      //console.log('SELECT LOCATION: ', location);
      this.selectLocation(location);
      if (this.linkToFactsheet == null || this.linkToFactsheet === '') {
        //TODO: Need to setup a option to show factsheet directly rather than print
        //this.setCurrentView('FactSheet');
        const print = new Print(
          appConfig.printPdfUrlConfig,
          appConfig.applicationUrl
        );
        const type =
          this.selectedItemType.toLowerCase() === 'geography' ? 'l' : 'f';
        this.printing = true;
        print
          .printToPDF(type, this.selectedItemValue)
          .then((pdf) => {
            this.printing = false;
            window.open(pdf, '_blank');
          })
          .catch((ex) => {
            this.printing = false;
            console.error(ex);
            this.setError('Print Service Timed Out. Please try again.');
          });
      } else {
        window.open(this.linkToFactsheet, 'blank');
      }
    }
  }
};
</script>

<style lang="scss">
.theme--light.v-text-field {
  .v-input__control {
    background-color: white;
    .v-input__slot:before {
      border-color: rgba(255, 255, 255, 1) !important;
    }
  }
}
nav {
  background-color: $ne-lightgray;
  .v-navigation-drawer__prepend {
    margin-bottom: 2px;
  }
}
.v-menu__content {
  font-family: $heading-font-family;
}
.v-navigation-drawer {
  overflow: visible !important;
  .v-btn__content {
    font-family: $heading-font-family;
  }
  .v-navigation-drawer__content {
    div:last-child {
      overflow: hidden;
    }
  }
}
div.overlap {
  background: $ne-lightgray;
  width: 10px;
  height: 48px;
  position: absolute;
  z-index: 5;
  top: 4px;
  right: -8px;
}
</style>
